import "./serverDown.css";

const ServerDown = () => {
    return (
        <div className="serverDownBackground">
            <div className="serverDownCard">
                <img
                    className="serverDownLogo"
                    src="https://ik.imagekit.io/dnddecpho/haofa/haofa%20logo_4_zlkAIvS.webp?updatedAt=1755148501071"
                    alt="HAOFA"
                />
                <h1 className="serverDownTitle">Admin Portal Unavailable</h1>
                <p className="serverDownMessage">
                    The admin portal is temporarily offline for maintenance.
                    Please try again later.
                </p>
                <span className="serverDownStatus">Server Down</span>
            </div>
        </div>
    );
};

export default ServerDown;
